import { Injectable } from '@angular/core';
import { delay, Observable, of } from 'rxjs';
import { fillArr } from '@pin-up-global/common';
import { ApiService, ListResponse } from '@shared/abstraction';
import { manageLoadingStatus } from '@shared/rxjs-operators';
import { BotLanguage } from './languages.abstraction';

@Injectable()
export class LanguagesApiServiceMock extends ApiService {
  isLoading$ = this._isLoading$;

  getLanguages(): Observable<ListResponse<BotLanguage>> {
    return of({
      items: fillArr(5, id =>
        ({
          id,
          name: `Language ${ id }`,
          code: `language_${ id }`,
          isActive: id % 2 === 1,
          isDefault: id === 0,
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
        }),
      ),
      count: 5,
    }).pipe(
      delay(1000),
      manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$),
    );
  }
}
